import { http } from "../httpHandler";
import { links } from "@/constants";
import { TServerErrorResponse } from "@/types/errors";
import {
  InstalledIntegration,
  InstalledIntegrationType,
} from "@/types/installedintegration";

export const InstalledIntegration_GET = "installedintegration-get";
export const InstalledIntegration_ALL_GET = "installedintegration-all-get";
export const InstalledIntegration_CLIENT_GET =
  "installedintegration-client-get";

export const getInstalledIntegration = async (id: string) => {
  try {
    const response = await http.get<InstalledIntegration>(
      links.installedintegration.installedIntegrationById(id),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getAllInstalledIntegrations = async () => {
  try {
    const response = await http.get<InstalledIntegration[]>(
      links.installedintegration.index,
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createIntegration = async (integration: {
  integration: InstalledIntegrationType;
  externalId: string;
}) => {
  try {
    const response = await http.post<InstalledIntegration>(
      links.installedintegration.index,
      integration,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteIntegration = async (id: string) => {
  try {
    const response = await http.delete<InstalledIntegration>(
      links.installedintegration.installedIntegrationById(id),
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
